import REDUX_NON_SAVABLE_ASSOCIATION
from 'modules/redux/constants/non-savable-association'
import getAssociationKeysReduxUtil
from 'modules/redux/utils/get-associations-keys'
import getLocalKeysReduxUtil from 'modules/redux/utils/get-local-keys'

function getSavableAssociationKeysReduxUtil (instance) {
  const associationKeys = getAssociationKeysReduxUtil(instance)
  const nonSavableAssociationKeys = [
    ...getLocalKeysReduxUtil(instance),
    ...(REDUX_NON_SAVABLE_ASSOCIATION[instance.className] || [])
  ]
  return (
    associationKeys.filter(associationKey =>
      !nonSavableAssociationKeys.includes(associationKey)
    )
  )
}

export default getSavableAssociationKeysReduxUtil
